(ns ui.editor2.local-assets
  "Finds the media of an editor2 design that never reached the server.

   A file that the user adds to a design is shown at once through a
   `blob:` object URL, which only the browser tab that created it can
   read. The upload adds the `:asset/uploaded-uri`, and
   `app.editor2.save-command` turns that into the permanent `/blob/`
   URI. A design that is saved while an asset still only has its `blob:`
   URL cannot be rendered: MLT draws its 'INVALID' placeholder instead
   of the image or video (brain-104)."
  (:require [clojure.string :as str]
            [datascript.core :as ds]))

(defn local-only-uri?
  [uri]
  (and (string? uri)
       (str/starts-with? uri "blob:")))

(defn local-only-asset?
  [asset]
  (and (local-only-uri? (:asset/uri asset))
       (not (:asset/uploaded-uri asset))))

(defn q-local-only-assets
  "The assets of the design `db` that a clip shows, but that only exist
   in the browser tab. Assets without a clip are left out: the user
   cannot see or remove them, and nothing renders them."
  [db]
  (->> (ds/q '[:find [?asset ...]
               :where
               [_ :clip/asset ?asset]]
             db)
       (map (fn [eid]
              (ds/entity db eid)))
       (filter local-only-asset?)
       (sort-by :db/id)))
